import { Filtering } from '@qualio/ui-components';
import { useMemo } from 'react';
import { DocumentStatus } from '../../../../../api/model/document';
import { defaultStatusFilterOption } from '../constants';

export const useDeleteDraftSelected = () => {
  const filtering = Filtering.useFilteringMaybe();

  const deletedDraftStatusSelected = useMemo(() => {
    const statusFilters =
      filtering?.filters.status?.value ?? defaultStatusFilterOption;
    return statusFilters === DocumentStatus.Deleted;
  }, [filtering?.filters.status?.value]);

  return deletedDraftStatusSelected;
};
